import React, { useCallback, useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, Chip, Modal, fmt, when } from "./kit";

// Otomatik bildirim: liste + gunluk saatler. Sistem her saatte siradaki (en uzun suredir gonderilmeyen) mesaji yollar.
const req = async (path, body) => {
  const r = await fetch(`${baseURL}autoPush/${path}`, {
    method: body ? "POST" : "GET",
    headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "", ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};
const HEDEF = { all: "Herkes", users: "Kullanıcılar", hosts: "Yayıncılar", inactive1: "1+ gün girmeyen", inactive3: "3+ gün girmeyen", inactive7: "7+ gün girmeyen" };
const inp = { width: "100%", padding: "7px 10px", border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 14 };

const AutoPush = () => {
  const [d, setD] = useState(null);
  const [duz, setDuz] = useState(null);
  const [saatler, setSaatler] = useState("");

  const load = useCallback(async () => {
    const r = await req("admin");
    if (r?.status) {
      setD(r);
      setSaatler((r.settings?.times || []).join(", "));
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  const ayarKaydet = async (enabled) => {
    const times = saatler.split(/[ ,]+/).filter(Boolean);
    const r = await req("admin/settings", { enabled, times });
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    load();
  };
  const kaydet = async () => {
    const r = await req("admin/save", duz);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    setDuz(null);
    load();
  };
  const yeni = () => setDuz({ title: "", message: "", arTitle: "", arMessage: "", enTitle: "", enMessage: "", target: "all", active: true, order: (d?.list?.length || 0) + 1 });
  const ac = (m) => setDuz({ _id: m._id, title: m.title, message: m.message, arTitle: m.i18n?.ar?.title || "", arMessage: m.i18n?.ar?.message || "", enTitle: m.i18n?.en?.title || "", enMessage: m.i18n?.en?.message || "", target: m.target, active: m.active, order: m.order });

  if (!d) return <div className="badu-empty">Yükleniyor…</div>;
  const s = d.settings || {};
  return (
    <>
      <PageHead
        title="Otomatik Bildirim"
        sub="Her gün belirlenen saatlerde listedeki sıradaki mesaj otomatik gönderilir. Kişinin diline göre Türkçe / Arapça / İngilizce gider."
        right={
          <button className="btn btn-primary" onClick={yeni}>
            + Yeni mesaj
          </button>
        }
      />
      <div className="card">
        <div className="card-body d-flex align-items-center" style={{ gap: 14, flexWrap: "wrap" }}>
          <label className="d-flex align-items-center" style={{ gap: 8, margin: 0, fontWeight: 700 }}>
            <input type="checkbox" checked={!!s.enabled} onChange={(e) => ayarKaydet(e.target.checked)} /> Otomatik gönderim {s.enabled ? "açık" : "kapalı"}
          </label>
          <span style={{ fontSize: 13 }}>Gönderim saatleri (Türkiye):</span>
          <input style={{ ...inp, width: 160 }} value={saatler} onChange={(e) => setSaatler(e.target.value)} placeholder="12:00, 20:00" />
          <button className="btn btn-outline-primary btn-sm" onClick={() => ayarKaydet(!!s.enabled)}>
            Saatleri kaydet
          </button>
          <span style={{ fontSize: 13, color: "#6B7280", marginLeft: "auto" }}>
            Sıradaki: <b>{d.next || "—"}</b>
          </span>
        </div>
      </div>

      <div style={{ display: "grid", gap: 8 }}>
        {d.list.map((m, i) => (
          <div key={m._id} className="card" style={{ margin: 0, opacity: m.active ? 1 : 0.55 }}>
            <div className="card-body" style={{ padding: "10px 14px", display: "grid", gridTemplateColumns: "28px minmax(200px,2fr) 150px 150px auto", gap: 12, alignItems: "center" }}>
              <span style={{ color: "#9CA3AF", fontWeight: 700 }}>{i + 1}</span>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.title}</div>
                <div style={{ fontSize: 12.5, color: "#6B7280", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.message}</div>
                <div style={{ fontSize: 11, color: "#9CA3AF" }}>
                  {m.i18n?.ar?.title ? "AR ✓" : "AR —"} · {m.i18n?.en?.title ? "EN ✓" : "EN —"}
                </div>
              </div>
              <div>
                <Chip kind={m.target.startsWith("inactive") ? "wait" : "ok"}>{HEDEF[m.target] || m.target}</Chip>
                <div style={{ fontSize: 11, color: "#6B7280", marginTop: 3 }}>≈ {fmt(d.counts?.[m.target] || 0)} kişi</div>
              </div>
              <div style={{ fontSize: 12, color: "#6B7280" }}>
                {m.lastSentAt ? `Son: ${when(m.lastSentAt)}` : "Henüz gönderilmedi"}
                <div>Toplam {fmt(m.sentCount)} teslim</div>
              </div>
              <div className="d-flex" style={{ gap: 6, justifyContent: "flex-end" }}>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => ac(m)}>
                  Düzenle
                </button>
                <button
                  className="btn btn-outline-success btn-sm"
                  onClick={async () => {
                    if (!window.confirm(`"${m.title}" şimdi ${HEDEF[m.target]} (${d.counts?.[m.target] || 0} kişi) için gönderilsin mi?`)) return;
                    const r = await req(`admin/${m._id}/send`, {});
                    window.alert(r?.status ? `${r.sent} kişiye teslim edildi` : r?.message || "Gönderilemedi");
                    load();
                  }}
                >
                  Şimdi gönder
                </button>
                <button className="btn btn-outline-danger btn-sm" onClick={async () => window.confirm("Mesaj silinsin mi?") && (await req(`admin/${m._id}/delete`, {})) && load()}>
                  🗑
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card" style={{ marginTop: 14 }}>
        <div className="card-body">
          <b>Son gönderimler</b>
          {(d.log || []).length === 0 ? (
            <div style={{ fontSize: 13, color: "#6B7280", marginTop: 6 }}>Henüz gönderim yok.</div>
          ) : (
            <table className="table table-sm" style={{ marginTop: 6 }}>
              <tbody>
                {d.log.map((l) => (
                  <tr key={l._id}>
                    <td style={{ fontSize: 12 }}>{when(l.createdAt)}</td>
                    <td>{l.title}</td>
                    <td style={{ fontSize: 12 }}>{HEDEF[l.target] || l.target}</td>
                    <td style={{ fontSize: 12 }}>{l.slot === "elle" ? "elle" : "otomatik"}</td>
                    <td style={{ fontSize: 12 }}>{fmt(l.sent)} teslim</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <Modal open={!!duz} title={duz?._id ? "Mesajı düzenle" : "Yeni mesaj"} onClose={() => setDuz(null)} wide>
        {duz && (
          <>
            <div className="d-flex" style={{ gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
              <div style={{ flex: 1, minWidth: 200 }}>
                <label style={{ fontSize: 13, fontWeight: 600 }}>Kime</label>
                <select style={inp} value={duz.target} onChange={(e) => setDuz({ ...duz, target: e.target.value })}>
                  {Object.entries(HEDEF).map(([k, l]) => (
                    <option key={k} value={k}>
                      {l} (≈ {d.counts?.[k] || 0})
                    </option>
                  ))}
                </select>
              </div>
              <label className="d-flex align-items-center" style={{ gap: 8, fontSize: 13, marginTop: 20 }}>
                <input type="checkbox" checked={duz.active} onChange={(e) => setDuz({ ...duz, active: e.target.checked })} /> Listede aktif
              </label>
            </div>
            {[
              ["Türkçe", "title", "message"],
              ["Arapça", "arTitle", "arMessage"],
              ["İngilizce", "enTitle", "enMessage"],
            ].map(([dil, t, m]) => (
              <div key={dil} style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 13, fontWeight: 700 }}>{dil}</label>
                <input style={{ ...inp, marginBottom: 6 }} dir={dil === "Arapça" ? "rtl" : "ltr"} placeholder="Başlık" value={duz[t]} onChange={(e) => setDuz({ ...duz, [t]: e.target.value })} />
                <textarea style={inp} rows={2} dir={dil === "Arapça" ? "rtl" : "ltr"} placeholder="Mesaj" value={duz[m]} onChange={(e) => setDuz({ ...duz, [m]: e.target.value })} />
              </div>
            ))}
            <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 10 }}>Arapça ya da İngilizce boşsa o dildeki kişilere Türkçe gider. Başlık en fazla 80, mesaj 240 karakter.</div>
            <button className="btn btn-primary w-100" onClick={kaydet}>
              Kaydet
            </button>
          </>
        )}
      </Modal>
    </>
  );
};

export default AutoPush;
